import { render, staticRenderFns } from "./MessageDisplayModal.vue?vue&type=template&id=9f4588bc&scoped=true&"
import script from "./MessageDisplayModal.vue?vue&type=script&lang=js&"
export * from "./MessageDisplayModal.vue?vue&type=script&lang=js&"
import style0 from "./MessageDisplayModal.vue?vue&type=style&index=0&id=9f4588bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f4588bc",
  null
  
)

export default component.exports